export default "/images/530efb71e734a2d36220bc452398c598.avif";